import React from 'react';
import LoginView from './LoginView'

export default () => {
  return <LoginView />
};